/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/221-man': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M9 1.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 019 1.5zM9 4H6a1 1 0 00-1 1v5h1v6h1.25v-6h.5v6H9v-6h1V5a1 1 0 00-1-1z"/>'
  }
})
